import React from 'react'
import { UserProvider } from './sub-contexts/userContext'
import { ThemeProvider } from './sub-contexts/themeContext'
import { HeaderProvider } from './sub-contexts/headerObserverContext'
import { SiteSpecificProvider } from './sub-contexts/siteSpecificProvider'
import { DevToolsProvider } from './sub-contexts/devToolsContext'

/*
    GlobalDailybreakContext represents the broader shared moving parts that the site needs, e.g.:
    - is this user a guest or are they logged in?
    - award the user points
    - a guest attempted to perform an action that requires an account - tell the site to pop some form of notifcation

    this this is global, try to keep it lean if possible

*/

const GlobalDailybreakContext = ({ children }) => {
  return (
    <ThemeProvider>
      <UserProvider>
        <DevToolsProvider>
          <HeaderProvider>
            <SiteSpecificProvider>{children}</SiteSpecificProvider>
          </HeaderProvider>
        </DevToolsProvider>
      </UserProvider>
    </ThemeProvider>
  )
}

export default GlobalDailybreakContext
